<script setup lang="ts">
  import { Text } from "../Text";

  const {
    label,
    size = "m",
    disabled = false,
    selected = false,
  } = defineProps<{
    label: string;
    size?: "s" | "m";
    disabled?: boolean;
    selected?: boolean;
  }>();
</script>

<template>
  <div class="chip" :class="[`chip--${size}`, { 'chip--active': selected }, { 'chip--disabled': disabled }]" :disabled="disabled">
    <Text :font="size === 's' ? 'body-regular-14' : 'body-regular-16'" :color="selected ? 'white' : 'secondary'" :wrap="false">
      {{ label }}
    </Text>
    <slot name="icon:after" />
  </div>
</template>

<style scoped>
  .chip {
    display: flex;
    gap: 2px;
    width: fit-content;
    background-color: var(--sf-chips-background-default);
  }

  .chip:hover {
    cursor: pointer;
    background-color: var(--sf-chips-background-hover);
  }

  .chip.chip--disabled {
    opacity: 0.4;
    background-color: var(--sf-chips-background-disabled);
  }

  .chip--active {
    background-color: var(--sf-chips-background-active-default);
  }

  .chip--active:hover {
    background-color: var(--sf-chips-background-active-hover);
  }

  .chip--active.chip--disabled {
    background-color: var(--sf-chips-background-active-disabled);
  }

  .chip--s {
    border-radius: 100px;
    padding: 8px 12px;
  }

  .chip--m {
    border-radius: 12px;
    padding: 12px 16px;
  }

  .chip--disabled {
    pointer-events: none;
  }
</style>
